import { render, staticRenderFns } from "./CreateConfirm.vue?vue&type=template&id=606f6209&scoped=true"
import script from "./CreateConfirm.vue?vue&type=script&lang=js"
export * from "./CreateConfirm.vue?vue&type=script&lang=js"
import style0 from "./CreateConfirm.vue?vue&type=style&index=0&id=606f6209&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606f6209",
  null
  
)

export default component.exports